import { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import CreateAccountAddressSearch from 'modules/CreateAccountAddressSearch'
import CreateListing from 'modules/CreateListing'
import ResumeListing from 'modules/ResumeListing'

import ExtraLargeHeader from 'components/ExtraLargeHeader'
import LoadingBox from 'components/LoadingBox'
import Spacer from 'components/Spacer'

import { QueryParamsContext } from 'services/contexts'
import { useUser } from 'services/swr/useUser'

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const ResumeListingContainer = styled.div`
  margin: 20px;
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

interface IHasUserProps {
  hasUser: boolean
}
const CreateContainer = styled.div<IHasUserProps>`
  width: 100%;
  background: ${props => props.theme.colors[props.hasUser ? 'grey2' : 'transparent']};
  padding: ${props => (props.hasUser ? 100 : 0)}px 15px 100px;
`

const CreateListingPage: NextPage = () => {
  const router = useRouter()
  const { params: query } = useContext(QueryParamsContext)

  const { user, isLoading: loadingUser } = useUser()

  const [replaced, setReplaced] = useState(false)

  useEffect(() => {
    if (
      Object.keys(query).length
      && Object.keys(query).some(key => query[key] !== router.query[key])
      && !replaced
    ) {
      setReplaced(true)
      router.replace('/', { query })
    }
  }, [])

  if (loadingUser) return <LoadingBox height={800} />

  return (
    <>
      <Head>
        {user
          ? (
            <title>List My Home For Sale - HomeLister</title>
          )
          : (
            <title>Create Your Free Listing Account - HomeLister</title>
          )}
        <meta
          name="description"
          content="Create your free flat fee MLS listing account to sell your home at HomeLister."
        />
        <meta
          name="keywords"
          content="Free Listing Account, Sell My Home, HomeLister"
        />
      </Head>
      {user
        ? (
          <ColumnContainer>
            <ResumeListingContainer>
              <ResumeListing />
            </ResumeListingContainer>
            <Container>
              <CreateContainer hasUser={!!user}>
                <ExtraLargeHeader
                  title="Or Enter a New Address"
                  noMargin={!!user}
                />
                <Spacer size={50} />
                <CreateListing />
              </CreateContainer>
            </Container>
          </ColumnContainer>
        )
        : (
          <CreateAccountAddressSearch />
        )}
    </>
  )
}

export default CreateListingPage
